import { defineAsyncComponent } from 'vue';

const components: { name: string, component: any }[] = [
    { name: 'rater-element', component: () => import('./Rater/RaterElement.vue') },
    { name: 'rater-input', component: () => import('./Rater/RaterInput.vue') },
    { name: 'float-email', component: () => import('./FloatEmail.vue') },
    { name: 'banner', component: () => import('./Banner.vue') },
    { name : 'testimonial' , component : () => import('./Testimonial.vue') },
    { name : 'news-overview' , component : () => import('./NewsOverview.vue') },
    { name: 'benefit', component: () => import('./Benefit.vue') },
    { name: 'statistic', component: () => import('./Statistic.vue') },
    { name: 'course-overview', component: () => import('./CourseOverview.vue') },
    { name: 'program-overview', component: () => import('./ProgramOverview.vue') },
    { name: 'category-overview', component: () => import('./CategoryOverview.vue') },
    { name: 'powered-by', component: () => import('./PoweredBy.vue') },
    // { name: 'card-course-dummy', component: () => import('./CardCourse-dummy.vue') },
    { name: 'card-course', component: () => import('./CardCourse.vue') },
    // { name: 'card-program-dummy', component: () => import('./CardProgram-dummy.vue') },
    { name: 'card-program', component: () => import('./CardProgram.vue') },
    // { name: 'quiz-dummy', component: () => import('./Quiz-dummy.vue') },
    { name: 'quiz', component: () => import('./Quiz.vue') },
    { name: 'layout-general-container', component: () => import('./Layout/General/Container.vue') },
    { name: 'layout-general-application-bar', component: () => import('./Layout/General/ApplicationBar.vue') },
    { name: 'layout-general-footer', component: () => import('./Layout/General/Footer.vue') },
    { name: 'layout-internal-container', component: () => import('./Layout/Internal/Container.vue') },
    { name: 'layout-internal-sidebar', component: () => import('./Layout/Internal/Sidebar.vue') },
    { name: 'layout-internal-application-bar', component: () => import('./Layout/Internal/ApplicationBar.vue') },
    { name: 'layout-authentication-container', component: () => import('./Layout/Authentication/Container.vue') },
    { name: 'form-apply', component: () => import('./Form/Apply.vue') },
    
    // Form Element
    { name: 'form-element-base', component: () => import('./Form/Element/Base.vue') },
    { name: 'form-element-label', component: () => import('./Form/Element/Label.vue') },
    { name: 'form-element-text', component: () => import('./Form/Element/Text.vue') },
    { name: 'form-element-textarea', component: () => import('./Form/Element/Textarea.vue') },
    { name: 'form-element-select-dropdown', component: () => import('./Form/Element/SelectDropdown.vue') },
    { name: 'form-element-select-dropdown-api', component: () => import('./Form/Element/SelectDropdownApi.vue') },
    { name: 'form-element-date', component: () => import('./Form/Element/Date.vue') },
    { name: 'form-element-number', component: () => import('./Form/Element/Number.vue') },
    { name: 'form-element-email', component: () => import('./Form/Element/Email.vue') },
    { name: 'form-element-file', component: () => import('./Form/Element/File.vue') },
    { name: 'form-element-image', component: () => import('./Form/Element/Image.vue') },
    { name: 'form-element-radio-button', component: () => import('./Form/Element/RadioButton.vue') },
    { name: 'form-element-checklist', component: () => import('./Form/Element/Checklist.vue') },
    { name: 'form-element-agreement', component: () => import('./Form/Element/Agreement.vue') },

];

export default {
    install(app: any) {
        components.forEach(({ name, component }) => {
            app.component(name, defineAsyncComponent(component));
        });
    }
};
